import React from 'react'
import PropTypes from 'prop-types'

class DigitalTemplateWrapper extends React.Component {
  _mapSectionGroups = () => {
    const { layoutData: { section_groups } } = this.props

    const groups = section_groups || []
    const filtered = groups.filter(group => group)

    const sorted = filtered.sort((a, b) => {
      const sortA = a && a.options ? a.options.sort : 0
      const sortB = b && b.options ? b.options.sort : 0

      return sortA > sortB ? 1 : -1
    })

    return sorted
  }

  render(){
    const { render } = this.props

    return render({
      sectionGroups: this._mapSectionGroups(),
    })
  }
}

DigitalTemplateWrapper.propTypes = {
  layoutData: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

export default DigitalTemplateWrapper
